<template>
  <span class="market-col-hd">
    初始化账户
    <el-tooltip :content="tip" placement="top">
      <i class="el-icon-question market-col-hd__icon"></i>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  name: "MarketColumnHeader",
  data() {
    return {
      tip: "初始化账户用于获取合约、行情等数据。",
    };
  },
};
</script>

<style scoped>
.market-col-hd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.market-col-hd__icon {
  margin-left: 4px;
  font-size: 14px;
  color: #5b85ff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/MarketColumnHeader.vue